import { Field } from 'components/Wizards/Field/Field'
import { Age } from './Age'
import { Gender } from './Gender'
import cx from 'classnames'
import Styles from './AudiencePreferences.module.scss'

type Props = {
  minAge?: number
  maxAge?: number
  gender?: string
  onMinAgeUpdate: (age: number | undefined) => void
  onMaxAgeUpdate: (age: number | undefined) => void
  onGenderUpdate: (gender: string) => void
}

const AudiencePreferences = ({ minAge, maxAge, gender, onMinAgeUpdate, onMaxAgeUpdate, onGenderUpdate }: Props) => {
  return (
    <Field label="Who you're speaking to" headingLevel={3} data-testid="audience-preferences">
      <div className={Styles.fields}>
        <div className={Styles.field}>
          <Age minAge={minAge} maxAge={maxAge} onMinAgeUpdate={onMinAgeUpdate} onMaxAgeUpdate={onMaxAgeUpdate} />
        </div>
        <div className={cx(Styles.field, Styles.genderField)}>
          <Gender gender={gender} onUpdate={onGenderUpdate} />
        </div>
      </div>
    </Field>
  )
}

export { AudiencePreferences }
